import * as types from '../mutation-types'

const state = {
  browserSettingsLanguage: null
}
const getters = {
  // getBrowserSettingsLanguage: state => state.browserSettingsLanguage
}
const actions = {
  saveBrowserSettingsLanguage({ commit }, locationLang) {
    // browserSettingsLanguage
    commit(types.BROWSER_SETTINGS_LANGUAGE, locationLang);
  }
}
const mutations = {
  [types.BROWSER_SETTINGS_LANGUAGE](state, lang) {
    state.browserSettingsLanguage = lang;
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/browserLang.js